// @flow
import React from "react";
import { connect } from "react-redux";
import { compose } from "ramda";
import { withI18n, Translate } from "@quantum/i18n";
import SelectInput from "../../../comum/SelectInput";
import type { Id, TipoDoRetorno } from "../../../../model";
import {
  type ActionCreator,
  selecionarTipoDoRetorno,
  getTiposDoRetorno,
  getTipoDoRetornoSelecionado,
} from "../../../../state";

type Prop = {
  listaTipoDoRetorno: Array<TipoDoRetorno>,
  tipoDoRetornoSelecionado: Id,
  selecionarTipoDoRetorno: ActionCreator,
};

function SelecaoTipoDoRetorno({
  listaTipoDoRetorno,
  tipoDoRetornoSelecionado,
  selecionarTipoDoRetorno,
}: Prop) {
  function handleTipoDoRetornoSelecionado(tipoDoRetorno) {
    selecionarTipoDoRetorno(tipoDoRetorno);
  }

  return (
    <div>
      <label className="ConfiguracaoMedida__label">
        <Translate>Comum.TipoDoRetorno</Translate>
      </label>
      <SelectInput
        className="ConfiguracaoMedida__input-select"
        value={tipoDoRetornoSelecionado}
        options={listaTipoDoRetorno}
        onChange={handleTipoDoRetornoSelecionado}
        multiple={false}
        size={listaTipoDoRetorno.length}
        campoDescricao={"chaveTraduzida"}
      />
    </div>
  );
}

export default compose(
  withI18n,
  connect(
    (state, { translate }) => ({
      listaTipoDoRetorno: getTiposDoRetorno(state).map(tipo => ({
        ...tipo,
        chaveTraduzida: translate(tipo.chaveTraducao),
      })),
      tipoDoRetornoSelecionado: getTipoDoRetornoSelecionado(state),
    }),
    { selecionarTipoDoRetorno }
  )
)(SelecaoTipoDoRetorno);
